import type { RootState } from "@/app/store";
import { EnsaioAnalise } from "@/contexts/laboratorio/ensaioAnalise/model/EnsaioAnalise";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EnsaioAnaliseState {
  items: EnsaioAnalise[];
  synced: boolean;
}

const initialState: EnsaioAnaliseState = {
  items: [],
  synced: false,
};

const ensaioAnaliseSlice = createSlice({
  name: "ENSAIO_ANALISE",
  initialState,
  reducers: {
    sync: {
      reducer: (state, action: PayloadAction<{ items: EnsaioAnalise[] }>) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: EnsaioAnalise[]) => ({
        payload: { items },
      }),
    },
  },
});

export const ensaioAnaliseAction = ensaioAnaliseSlice.actions;

export default ensaioAnaliseSlice.reducer;

export const getEnsaiosAnaliseSynced = (state: RootState) =>
  state.ensaioAnalise.items;
